import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { GIButton, Modal } from 'app-components';

interface IErrorModal {
    titleId: string;
    errorText: string | ReactNode;
    onClose: () => void;
}

const StyledModal = styled.div`
    .gi-modal__content {
        width: 500px;
    }
    .gi-modal__body,
    .gi-modal__controls {
        display: flex;
        justify-content: center;
    }
`;

export const ErrorModal = (props: IErrorModal) => {
    const { titleId = 'ticketList.modal.errorModal.header.error', errorText, onClose } = props;

    return (
        <StyledModal>
            <Modal id="errorModal">
                <Modal.Header id="errorModalHeader" titleId={titleId} onHide={onClose} />
                <Modal.Body>{errorText}</Modal.Body>
                <Modal.Controls>
                    <GIButton
                        id="errorModalNoButton"
                        onClickHandler={onClose}
                        variant="primary"
                        labelId="button.close"
                    />
                </Modal.Controls>
            </Modal>
        </StyledModal>
    );
};
